/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material-module';
import { ButtonFooterComponent } from './button-footer/button-footer.component';

@NgModule({
	declarations: [ButtonFooterComponent],
	imports: [MaterialModule],
	exports: [ButtonFooterComponent],
})
export class PresentationModule {}
